import {WithContext, FAQPage, Question, Answer} from 'schema-dts'

export interface FAQSchemaEntry {
  name: string
  text: string
}

const FAQSchema = ({faqs}: {faqs: FAQSchemaEntry[]}) => {
  if (!faqs || faqs.length === 0) {
    return null
  }

  const mainEntity: Question[] = faqs.map(({name, text}) => ({
    '@type': 'Question',
    name,
    acceptedAnswer: {
      '@type': 'Answer',
      text,
    },
  }))

  const jsonLd: WithContext<FAQPage> = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity,
  }

  return (
    <script id='faq-schema' type='application/ld+json' dangerouslySetInnerHTML={{__html: JSON.stringify(jsonLd)}} />
  )
}

export default FAQSchema
